import React, { useMemo } from "react";
import { Select, Input, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const PlanerFilters = ({
  departments = [],
  teams = [],
  department,
  team,
  employeeSearch,
  onDepartmentChange,
  onTeamChange,
  onEmployeeSearchChange,
}) => {
  const deptOptions = useMemo(
    () => [
      { value: "", label: "Të gjitha departamentet" },
      ...departments.map((d) => ({
        value: d.departmentName,
        label: d.departmentName,
      })),
    ],
    [departments]
  );

  const teamOptions = useMemo(
    () => [
      { value: "", label: "Të gjitha ekipet" },
      ...teams.map((t) => ({ value: t, label: t })),
    ],
    [teams]
  );

  return (
    <Space wrap className="planer-filters" size={12}>
      <Select
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 200 }}
        value={department || ""}
        options={deptOptions}
        onChange={onDepartmentChange}
        placeholder="Departamenti"
      />
      <Select
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 180 }}
        value={team || ""}
        options={teamOptions}
        onChange={onTeamChange}
        placeholder="Ekipi"
      />
      <Input
        allowClear
        prefix={<SearchOutlined />}
        style={{ minWidth: 220 }}
        placeholder="Kërko punonjës…"
        value={employeeSearch}
        onChange={(e) => onEmployeeSearchChange(e.target.value)}
      />
    </Space>
  );
};

export default PlanerFilters;
